<template>
<section class="content">
    <div class="box box-info">
      <a href="#"   @click.prevent="exportCSV()" >
       <img src="../../../../../static/img/excel.png" style="width: 4%;float: right;"/>
      </a>
    </div>
    <div>
    <DataTable ref="po"
      :value="smsDetailsQueueLists"
      :paginator="true"
      :rows="10"  :filters="filters"
      class="p-datatable-responsive-demo">
      <Column header="S.n" >
      <template #body="slotProps">
        {{slotProps.index+1}}
      </template>
      </Column>
      <Column :sortable="true" 
        header="Contact Number"
        field="mobileNumber"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['mobileNumber']" />
        </template>
      </Column>
      <Column :sortable="true" 
        header="Message"
        field="smsText"
        filterMatchMode="contains"
      >
       <template #filter>
         <InputText type="text" class="p-column-filter" v-model="filters['smsText']" />
       </template>
      </Column>
    </DataTable>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-10"></div>
        <div class="p-field p-col-12 p-md-2 p-mt-2">
          <Button style="float:right"  class="p-button-raised p-button-success" label="Send Sms"
           @click.prevent="sendSms()"/>
         </div>
       </div>
  </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import globalKey from '../../../../store/globalKey'
export default {
  name: 'smsReport',
  data () {
    return {
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button
  },
  computed: {
    smsDetailsQueueLists() {
      return this.$store.state.admin.smsDetailsQueueLists
    }
  },
  mounted() {
    this.smsDetailsQueueList()
    this.columnNames()
  },
  methods: {
    async smsDetailsQueueList() {
      try {
        await this.$store.dispatch('loadQueueSmsList')
      } catch (e) {}
    },
    async sendSms() {
      let resp = ''
      this.loading = !this.loading
      resp = await this.$store.dispatch('sendSms')
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
        this.unSettleSalesChildHeaderLists = []
      }
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Account List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'accountList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// smsReport.vue?3b060d4d